module.exports = __webpack_public_path__ + "img/dp-dy-sh7.fbec088d.png";